import './UpSelectBtn.scss';
import React, { CSSProperties, useEffect, useState } from 'react';
import classNames from 'classnames';
export type KEY = string | number;
interface IUpSelectBtn {
  list: {
    key: KEY;
    name: string;
  }[];
  selectKey: KEY;
  setKey: (key: KEY) => void;
  style?: CSSProperties;
}
export default function(props: IUpSelectBtn) {
  const [select, setSelect] = useState(false);
  const { list, selectKey, setKey, style } = props;
  const current = list.find(one => one.key === selectKey);

  // 选完后自动关闭选择框
  useEffect(() => {
    setSelect(false);
  }, [selectKey]);
  return (
    <div className="up-select-wrapper" style={style}>
      {select && (
        <ul className={'select-list'}>
          {list.map(one => (
            <li
              className={selectKey === one.key ? 'active' : ''}
              key={one.key}
              onClick={() => {
                setKey(one.key);
              }}
            >
              {one.name}
            </li>
          ))}
        </ul>
      )}
      <div className="up-select-btn" onClick={() => setSelect(sel => !sel)}>
        {current?.name}{' '}
        <img
          src={require('../../assets/up-triangle.png')}
          alt={''}
          className={classNames('triangle', { down: select })}
        />
      </div>
    </div>
  );
}
